import { useState } from "react";

import {
  ICheckoutPageContext,
  ICreateSaleLineItem,
  IInitPaymentLinkTransactionRequest,
} from "../interfaces-and-types";
import { getCountryCode } from "../utils";
import { CheckoutPageContext } from "./CheckoutPageContext";

export function CheckoutPageProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [line_items, setLineItemsState] = useState<ICreateSaleLineItem[]>([]);
  const [customer, setCustomer] = useState<
    IInitPaymentLinkTransactionRequest["customer"]
  >({
    email: "",
  });

  const [isInitialized, setIsInitialized] = useState(false);

  const [checkoutItemsLocked, setCheckoutItemsLocked] = useState(false);
  const lockCheckoutItems = () => setCheckoutItemsLocked(true);

  const [paymentMethodSwitcherVisible, setPaymentMethodSwitcherVisible] =
    useState(true);
  const showPaymentMethodSwitcher = () => setPaymentMethodSwitcherVisible(true);
  const hidePaymentMethodSwitcher = () =>
    setPaymentMethodSwitcherVisible(false);

  const [country, setCountry] = useState(getCountryCode("NG"));

  const [searchLineItemsText, setSearchLineItemsTextState] = useState<
    string | null
  >(null);

  const [saleCurrency, setSaleCurrency] = useState("");
  const [saleTotal, setSaleTotal] = useState(0);

  const setLineItems = (line_items: ICreateSaleLineItem[]) => {
    setLineItemsState(line_items);
    setIsInitialized(true);
  };

  const setSearchLineItemsText = (value: string | null) =>
    setSearchLineItemsTextState(value?.toLowerCase() || null);

  const unMemoedCheckoutPageContext: ICheckoutPageContext = {
    // state
    isInitialized,

    // checkout lock
    checkoutItemsLocked,
    lockCheckoutItems,

    // payment switcher visibility
    paymentMethodSwitcherVisible,
    showPaymentMethodSwitcher,
    hidePaymentMethodSwitcher,

    // country
    country,
    setCountry,

    // customer
    customer,
    setCustomer,

    // total & currency code
    saleCurrency,
    setSaleCurrency,
    saleTotal,
    setSaleTotal,

    // line items
    line_items,
    setLineItems,
    searchLineItemsText,
    setSearchLineItemsText,
  };

  return (
    <CheckoutPageContext.Provider value={unMemoedCheckoutPageContext}>
      {children}
    </CheckoutPageContext.Provider>
  );
}
